import styled from "@emotion/styled";

export const Backdrop = styled.div`
  position: fixed;
  inset-block: 0 0;
  inset-inline: 0 0;
  z-index: -1;

  opacity: 0.8;
  -webkit-tap-highlight-color: transparent;
`;

export const DarkBackdrop = styled(Backdrop)`
  background-color: #27303e;
`;

export const LightBackdrop = styled(Backdrop)`
  background-color: #ffffff;
`;
